import React, { useState } from 'react';
import { motion } from 'framer-motion';

const FlipTile = ({ title, icon, description, color }) => {
  const [isFlipped, setIsFlipped] = useState(false);
  
  // Detect if mobile for touch events
  const isMobile = window.innerWidth < 768;
  
  const handleFlip = () => {
    if (isMobile) {
      setIsFlipped(!isFlipped);
    }
  };

  return (
    <div 
      className="flip-tile-container h-64 perspective-1000 w-full cursor-pointer"
      onClick={handleFlip}
      onMouseEnter={() => !isMobile && setIsFlipped(true)}
      onMouseLeave={() => !isMobile && setIsFlipped(false)}
    >
      <motion.div
        className="flip-tile relative w-full h-full transition-all duration-500"
        animate={{ rotateY: isFlipped ? 180 : 0 }}
        transition={{ duration: 0.5 }}
        style={{ transformStyle: 'preserve-3d' }}
      >
        {/* Front Side */}
        <div 
          className={`absolute inset-0 flex flex-col items-center justify-center ${color} rounded-xl shadow-normal p-6 backface-hidden`}
        >
          <div className="text-4xl mb-4">{icon}</div>
          <h3 className="text-xl font-bold text-primary-700">{title}</h3>
        </div>
        
        {/* Back Side */}
        <div 
          className="absolute inset-0 flex flex-col items-center justify-center bg-primary-700 text-white rounded-xl shadow-normal p-6 backface-hidden"
          style={{ transform: 'rotateY(180deg)' }}
        >
          <p className="text-center mb-4">{description}</p>
          <a 
            href="https://calendly.com/adam-cothes/va-consultation" 
            target="_blank"
            rel="noopener noreferrer"
            className="mt-auto bg-white text-primary-700 hover:bg-primary-50 px-4 py-2 rounded-lg font-medium transition-colors"
            onClick={(e) => e.stopPropagation()}
          >
            Book Appointment
          </a>
        </div>
      </motion.div>
    </div>
  );
};

export default FlipTile;